<template>
  <div>
    <v-data-table
      fixed-header
      dense
      :height="groupBy.length ? 530 : 470"
      :group-by="groupByValue"
      :custom-group="customGroupBy"
      :headers="headers"
      :items="history"
      :hide-default-footer="!!groupBy.length"
      :disable-pagination="!!groupBy.length"
      :footer-props="{
              'items-per-page-options': [20, 30, 50, -1]
          }"
    >
      <template v-slot:[`group.header`]="{ items, isOpen, toggle, headers }">
        <td
          v-if="fromRequestModule"
          :colspan="headers.length - 7"
          class="primary white--text group-td"
        >
          <div class="d-flex align-center">
            <v-btn
              icon
              small
              @click="toggle"
            >
              <v-icon color="white">
                {{ isOpen ? 'mdi-chevron-up' : 'mdi-chevron-down' }}
              </v-icon>
            </v-btn>
            <span class="subtitle-2 ml-2">{{ groupTitle(items[0]) }}</span>
          </div>
        </td>
        <td
          :colspan="3"
          class="primary white--text text-no-wrap px-2"
        >
          <div class="d-flex align-center">
            <span>Total: {{ totalAmount(items) }}</span>
          </div>
        </td>
        <td
          :colspan="4"
          class="primary white--text text-no-wrap px-2"
        >
          <div class="d-flex align-center">Amount : {{ items.length }}</div>
        </td>
      </template>
      <template v-slot:[`item.Is_Pending`]="{ item }">
        <span
          v-if="(
            item.Status === statusNames.Accountant_Pending ||
            item.Status === statusNames.Employee_Pending ||
            item.Status === statusNames.AMPending
          )"
          class="orange--text darken-2 text-no-wrap"
        >
          {{ item.Status }}
        </span>
        <span
          v-if="!item.Is_Pending"
          class="primary--text darken-2"
        >
          Considered
        </span>
      </template>
      <template v-slot:[`item.Approved`]="{ item }">
        <span
          v-if="item.Approved && !item.Is_Pending"
          class="success--text darken-2"
        >
          Approved by {{ item.Confirmer_Full_Name }}
        </span>
        <span
          v-else-if="!item.Approved && item.Rejection_Reason && item.AM_Approved && !item.Is_Pending"
          class="error--text darken-2"
        >
          Rejected by {{ item.Confirmer_Full_Name }}<br>
          <b>Reason: {{ item.Rejection_Reason }}</b>
        </span>
        <span v-else class="info--text darken-2">
          On pending
        </span>
      </template>
      <template v-slot:[`item.AM_Approved`]="{ item }">
        <span
          v-if="item.AM_Approved"
          class="success--text darken-2"
        >
          Approved by {{ item.AM_Confirmer_Full_Name }}
        </span>
        <span
          v-if="!item.AM_Approved && item.Rejection_Reason"
          class="error--text darken-2"
        >
          Rejected by {{ item.AM_Confirmer_Full_Name }}
          <b>Reason: {{ item.Rejection_Reason }}</b>
        </span>
      </template>
      <template v-slot:[`item.Confirmation_File_Name`]="{ item }">
        <v-layout v-if="!item.Confirmation_File_Name && !fromRequestModule">
          <span style="cursor:pointer">
            <span
              @click="addFile('Payment confirmation', item)"
              v-if="item.AM_Approved && item.Is_Pending && !item.Approved"
              class="success--text"
            >
              Add file
            </span>
            <span
              v-else
              class="grey--text darken-2"
            >
              Add file
            </span>
            <v-btn
              @click="addFile('Payment confirmation', item)"
              :disabled="!(item.AM_Approved && item.Is_Pending && !item.Approved)" icon
              color="success"
            >
              <v-icon>mdi-file-plus</v-icon>
            </v-btn>
          </span>
        </v-layout>
        <a
          v-else-if="item.Confirmation_File_Name"
          @click="getLAndDFile(item.Confirmation_File_Name, item.Request_ID, 'Confirmation_File', item.Confirmation_File_Type)"
        >{{ item.Confirmation_File_Name }}</a>
      </template>
      <template v-slot:[`item.Amount_Of_Compensation`]="{ item }">
        <span>
          {{ item.Amount_Of_Compensation + (item.Is_USD ? ' $' : ' uah') }}
        </span>
      </template>
      <template v-slot:[`item.Agreement_File_Name`]="{ item }">
        <v-layout v-if="!item.Agreement_File_Name && !fromRequestModule">
          <span style="cursor:pointer">
            <span
              @click="addFile('Educational agreement', item)"
              v-if="item.AM_Approved && item.Is_Pending && !item.Approved"
              class="success--text"
            >
              Add file
            </span>
            <span
              v-else
              class="grey--text darken-2"
            >
              Add file
            </span>
            <v-btn
              @click="addFile('Educational agreement', item)"
              :disabled="!(item.AM_Approved && item.Is_Pending && !item.Approved)" icon
              color="success"
            >
              <v-icon>mdi-file-plus</v-icon>
            </v-btn>
          </span>
        </v-layout>
        <a
          v-else-if="item.Agreement_File_Name"
          @click="getLAndDFile(item.Agreement_File_Name, item.Request_ID, 'Agreement_File', item.Agreement_File_Type)"
        >{{ item.Agreement_File_Name }}</a>
      </template>
      <template v-slot:[`item.Payout_Month`]="{ item }">
        <span v-if="fromRequestModule" class="d-flex margin-top--10">
          <DatePicker
            v-model="item.Payout_Month"
            :disabled="item.Status === statusNames.Accountant_Pending || item.Status === statusNames.Rejected"
            type="month"
            @onDatePickerChange="updatePayoutMonth(item)"
          />
        </span>
        <span v-else>
          {{ item.Payout_Month }}
        </span>
      </template>
      <template v-slot:[`item.Edit_Manage`]="{ item }">
        <td class="text-center text-no-wrap">
        <template>
          <v-tooltip bottom color="info">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                small
                icon
                :disabled="!item.Is_Pending"
                v-bind="attrs"
                v-on="on"
                color="info"
                @click="openRequest(item)"
              >
                <v-icon> mdi-pencil </v-icon>
              </v-btn>
            </template>
            <span>Edit</span>
          </v-tooltip>
          <v-tooltip bottom color="red darken-2">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                small
                icon
                :disabled="!item.Is_Pending"
                v-bind="attrs"
                v-on="on"
                color="red darken-2"
                @click="openDeleteDialog(item)"
              >
                <v-icon> mdi-delete </v-icon>
              </v-btn>
            </template>
            <span>Delete</span>
          </v-tooltip>
        </template>
      </td>
      </template>
      <template v-slot:[`item.Manage`]="{ item }">
        <td class="text-center text-no-wrap">
          <template v-if="item.Is_Pending">
          <v-tooltip bottom color="success">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                small
                icon
                v-bind="attrs"
                v-on="on"
                :disabled="!item.Confirmation_File_Name"
                color="success"
                @click="openAcceptDialog(item)"
              >
                <v-icon> mdi-check-circle </v-icon>
              </v-btn>
            </template>
            <span>Approve</span>
          </v-tooltip>
          <v-tooltip bottom color="red darken-2">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                small
                icon
                v-bind="attrs"
                v-on="on"
                :disabled="!item.Confirmation_File_Name"
                color="red darken-2"
                @click="openRejectDialog(item)"
              >
                <v-icon> mdi-close-circle </v-icon>
              </v-btn>
            </template>
            <span>Reject</span>
          </v-tooltip>
        </template>
        <template v-else>
          <v-tooltip bottom color="blue darken-2">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                small
                icon
                v-bind="attrs"
                v-on="on"
                color="blue darken-2"
                @click="openPendingDialog(item)"
              >
                <v-icon> mdi-pencil </v-icon>
              </v-btn>
            </template>
            <span>To pending</span>
          </v-tooltip>
        </template>
        </td>
      </template>
    </v-data-table>
    <v-dialog
      v-model="showRejectDialog"
      max-width="300px"
    >
      <v-card>
        <v-card-title>
          <v-textarea
            rows="2"
            label="Rejection reason"
            v-model="rejectionReason"
          >
          </v-textarea>
        </v-card-title>
        <v-card-actions>
          <v-btn small outlined color="primary" @click="showRejectDialog = false">
            Cancel
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn small :disabled="!rejectionReason" color="red darken-2 white--text" @click="considerRequest(false)">
            Reject
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="showPendingDialog"
      max-width="300px"
    >
      <v-card>
        <v-card-title>
          <v-textarea
            rows="2"
            label="Pending reason"
            v-model="pendingReason"
          >
          </v-textarea>
        </v-card-title>
        <v-card-actions>
          <v-btn small outlined color="primary" @click="showPendingDialog = false">
            Cancel
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn small :disabled="!pendingReason" color="blue darken-2 white--text" @click="considerRequest(false)">
            To pending
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <ConfirmOrDeniedDialog
      v-if="showAcceptDialog"
      v-model="showAcceptDialog"
      :mode="confirmOrDeniedDialogModes.confirmation"
      :message="'Approve request?'"
      :confirmBtnName="'Approve'"
      @onApproveClick="considerRequest(true)"
      @onCancelClick="showAcceptDialog = false"
      @onCloseClick="showAcceptDialog = false"
    />
    <ConfirmOrDeniedDialog
      v-if="showDeleteDialog"
      v-model="showDeleteDialog"
      :mode="confirmOrDeniedDialogModes.delete"
      @onDeleteClick="deleteRequest"
      @onCancelClick="showDeleteDialog = false"
      @onCloseClick="showDeleteDialog = false"
    />
    <LAndDFileInputDialog
      v-if="showLAndDFileInputDialog"
      v-model="showLAndDFileInputDialog"
      :request="currentRequest"
      :fileClass="currentFileClass"
      @updateFileInfo="updateFileInfo"
    />
    <LAndDRequest
      v-if="requestForLAndDDialog"
      v-model="requestForLAndDDialog"
      :requestId="requestForLAndDId"
      :accountManagers="accountManagers"
      @getHistory="getHistory"
    />
  </div>
</template>
<script>
export default {
  components: {
    LAndDFileInputDialog: () => import('@/components/employee/employee_requests/LAndDFileInputDialog'),
    ConfirmOrDeniedDialog: () => import('@/components/global/ConfirmOrDeniedDialog.vue'),
    DatePicker: () => import('@/components/global/DatePicker.vue'),
    LAndDRequest: () => import('@/components/employee/employee_requests/LAndDRequest')

  },
  name: 'LAndDRequestHistory',
  props: {
    value: {
      required: true,
      default: false
    },
    employeeId: {
      required: false,
      default: null
    },
    dateFrom: {
      required: false,
      default: null
    },
    dateTo: {
      required: false,
      default: null
    },
    groupBy: {
      required: false,
      default: () => {
        return []
      }
    },
    fromRequestModule: {
      required: false,
      default: false
    },
    showListEmployee: {
      required: false,
      default: false
    }
  },
  data () {
    return {
      history: [],
      consideringRequest: null,
      currentRequest: null,
      currentFileClass: null,
      showLAndDFileInputDialog: false,
      showRejectDialog: false,
      showAcceptDialog: false,
      showPendingDialog: false,
      showDeleteDialog: false,
      requestForLAndDDialog: null,
      requestForLAndDId: null,
      accountManagers: [],
      rejectionReason: null,
      pendingReason: null,
      downloadLink: document.createElement('a'),
      statusNames: {
        Accountant_Pending: 'Acc. Pending',
        Employee_Pending: 'Emp. Pending',
        AMPending: 'AM Pending',
        Rejected: 'Rejected',
        Approved: 'Approved'
      },
      groupByValue: [],
      groupByText: []
    }
  },
  mounted () {
    this.getHistory()
  },
  computed: {
    user () {
      return this.$store.getters.getUser
    },
    confirmOrDeniedDialogModes () {
      return this.$store.getters.getConfirmOrDeniedDialogModes
    },
    headers () {
      return [
        {
          text: 'Employee',
          value: 'Request_Owner',
          divider: true,
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-pre-wrap',
          show: this.showListEmployee
        },
        {
          text: 'Created',
          value: 'Date_Of_Create',
          divider: true,
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-pre-wrap',
          show: true
        },
        {
          text: 'Updated',
          value: 'Date_Of_Update',
          divider: true,
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-pre-wrap',
          show: true
        },
        {
          text: 'Course link',
          value: 'Link_To_Course',
          divider: true,
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-pre-wrap',
          show: true
        },
        {
          text: 'Course name',
          value: 'Course_Name',
          divider: true,
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-pre-wrap',
          show: true
        },
        {
          text: 'Payment confirmation',
          value: 'Confirmation_File_Name',
          divider: true,
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-pre-wrap',
          show: true
        },
        {
          text: 'Educational agreement',
          value: 'Agreement_File_Name',
          divider: true,
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-pre-wrap',
          show: true
        },
        {
          text: 'Amount',
          value: 'Amount_Of_Compensation',
          width: '5%',
          divider: true,
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-pre-wrap',
          show: true
        },
        {
          text: 'Course taking reason',
          value: 'Course_Taking_Reason',
          divider: true,
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-pre-wrap',
          show: true
        },
        {
          text: 'Confirmer',
          value: 'Confirmer_Full_Name',
          divider: true,
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-pre-wrap',
          show: !this.fromRequestModule
        },
        {
          text: 'Comments',
          value: 'Comments',
          divider: true,
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-pre-wrap',
          show: true
        },
        {
          text: 'Accural Month',
          value: 'Payout_Month',
          divider: true,
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-pre-wrap',
          show: true
        },
        {
          text: 'Status',
          value: 'Is_Pending',
          divider: true,
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-pre-wrap',
          show: true
        },
        {
          text: 'L&D approved',
          value: 'AM_Approved',
          divider: true,
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-pre-wrap',
          show: true
        },
        {
          text: 'Accountant approved',
          value: 'Approved',
          divider: true,
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-pre-wrap',
          show: true
        },
        {
          text: 'Manage',
          value: 'Edit_Manage',
          divider: true,
          class: 'px-2 text-no-wrap',
          cellClass: 'px-2 text-pre-wrap',
          show: !this.fromRequestModule
        },
        {
          text: 'Manage',
          value: 'Manage',
          class: 'px-2 text-center',
          width: '50px',
          sortable: false,
          show: this.fromRequestModule
        }
      ].filter(item => item.show)
    }
  },
  methods: {
    getHistory () {
      const historyOfEmployee = this.showListEmployee ? 'none' : this.employeeId || this.user.employee_id
      this.axios.get(`/api/requests/l_and_d/${historyOfEmployee}` +
        (this.dateFrom ? `/${this.dateFrom}` : '') +
        (this.dateTo ? `/${this.dateTo}` : ''), {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.history = res.data
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      })
    },
    normalizeStatus (status) {
      const pendingStatuses = ['Acc. Pending', 'Emp. Pending', 'AM Pending']
      return pendingStatuses.includes(status) ? 'Pending' : status
    },
    customGroupBy (items, groupBy) {
      const groups = []
      items.forEach(item => {
        let cId = ''
        for (let i = 0; i < groupBy.length; i++) {
          let value = item[groupBy[i]]
          if (groupBy[i] === 'Status') {
            value = this.normalizeStatus(value)
          }
          cId += value
        }
        const group = groups.find(g => g.name === cId)
        if (group) {
          group.items.push(item)
        } else {
          groups.push({
            name: cId,
            items: [item]
          })
        }
      })
      return groups
    },
    groupTitle (item) {
      let str = ''
      for (let i = 0; i < this.groupBy.length; i++) {
        let value = item[this.groupBy[i].value]
        if (this.groupBy[i].value === 'Status') {
          value = this.normalizeStatus(value)
        }
        str += value ? value + (i === this.groupBy.length - 1 ? '' : ', ') : 'Other' + (i === this.groupBy.length - 1 ? '' : ', ')
      }
      return str
    },
    totalAmount (items) {
      const result = items.reduce((total, item) => {
        if (item.Is_USD) {
          total.USD.amount += item.Amount_Of_Compensation
        } else {
          total.UAH.amount += item.Amount_Of_Compensation
        }
        return total
      }, {
        USD: { sign: '$', amount: 0 },
        UAH: { sign: '₴', amount: 0 }
      })
      const USDStr = result.USD.amount ? result.USD.amount + result.USD.sign : ''
      const UAHStr = result.UAH.amount ? result.UAH.amount + result.UAH.sign : ''
      return (USDStr || '') + (UAHStr && USDStr ? ' / ' : '') + (UAHStr || '')
    },
    linkToFile (data, type) {
      let res = ''
      let binary = ''
      const bytes = new Uint8Array(data)
      const len = bytes.byteLength
      for (let i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i])
      }
      res = `data:${type};base64, ${window.btoa(binary)}`
      return res
    },
    openFile (filename, data, type) {
      const linkSource = this.linkToFile(data, type)
      this.downloadLink.href = linkSource
      this.downloadLink.download = filename
      this.downloadLink.click()

      setTimeout(() => {
        this.downloadLink.href = ''
      })
    },
    getLAndDFile (filename, requestId, kindOfFile, typeOfFile) {
      this.axios.get(`/api/requests/l_and_d_file/${requestId}/${kindOfFile}`, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(res => {
        this.openFile(filename, res.data[0].File.data, typeOfFile)
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      })
    },
    deleteRequest () {
      this.axios.delete(`/api/requests/l_and_d/${this.consideringRequest.Request_ID}`, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(() => {
        this.axios.delete(`/api/notifications/${this.consideringRequest.Notification_ID}`, {
          headers: {
            Authorization: 'Bearer ' + this.user.token
          }
        }).then(() => {
          this.$store.dispatch('setSuccess', { successMsg: 'Notification was deleted' })
        }).catch(error => {
          this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
        })
        this.$store.dispatch('setSuccess', { successMsg: 'Request was deleted' })
        this.getHistory()
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      }).finally(() => {
        this.requestForLAndDDialog = false
      })
    },
    getLAndDList () {
      if (!this.accountManagers.length) {
        this.axios.get('/api/l_and_d_approvers', {
          headers: {
            Authorization: 'Bearer ' + this.user.token
          }
        }).then(result => {
          this.accountManagers = result.data
        }).catch(error => {
          this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
        })
      }
    },
    addFile (fileClass, item) {
      this.currentFileClass = fileClass
      this.currentRequest = item
      this.showLAndDFileInputDialog = true
    },
    updateFileInfo () {
      this.axios.get(`/api/requests/l_and_d_request/${this.currentRequest.Request_ID}`, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(result => {
        if (result.data[0].Confirmation_File_Name) {
          this.currentRequest.Status = 'Acc. Pending'
        }
        this.currentRequest.Rejection_Reason = this.currentRequest.Confirmer_ID =
          this.currentRequest.Confirmer_Full_Name = null
        this.currentRequest.Date_Of_Update = result.data[0].Date_Of_Update
        this.currentRequest.Confirmation_File_Name = result.data[0].Confirmation_File_Name
        this.currentRequest.Confirmation_File_Type = result.data[0].Confirmation_File_Type
        this.currentRequest.Agreement_File_Name = result.data[0].Agreement_File_Name
        this.currentRequest.Agreement_File_Type = result.data[0].Agreement_File_Type
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      })
    },
    openRejectDialog (item) {
      this.consideringRequest = item
      this.showRejectDialog = true
    },
    openAcceptDialog (item) {
      this.consideringRequest = item
      this.showAcceptDialog = true
    },
    openPendingDialog (item) {
      this.consideringRequest = item
      this.showPendingDialog = true
    },
    openDeleteDialog (item) {
      this.consideringRequest = item
      this.showDeleteDialog = true
    },
    openRequest (item) {
      this.requestForLAndDId = item.Request_ID
      this.getLAndDList()
      this.requestForLAndDDialog = true
    },
    considerRequest (approved) {
      if (approved) {
        this.consideringRequest.Rejection_Reason = null
        this.consideringRequest.Approved = 1
        this.consideringRequest.Status = this.statusNames.Approved
        this.consideringRequest.Is_Pending = 0
      } else if (this.pendingReason) {
        this.consideringRequest.Rejection_Reason = this.pendingReason
        this.consideringRequest.Approved = 0
        this.consideringRequest.Is_Pending = 1
        this.consideringRequest.Status = this.statusNames.Accountant_Pending
      } else {
        this.consideringRequest.Rejection_Reason = this.rejectionReason
        this.consideringRequest.Approved = 0
        this.consideringRequest.Is_Pending = 0
        this.consideringRequest.Status = this.statusNames.Rejected
      }
      this.consideringRequest.Confirmer_Full_Name = this.user.full_name
      this.consideringRequest.Date_Of_Update = new Date().toISOString().substr(0, 10)

      this.axios.put('/api/requests/consider_l_and_d',
        {
          Request_ID: this.consideringRequest.Request_ID,
          Approved: this.consideringRequest.Approved,
          Rejection_Reason: this.consideringRequest.Rejection_Reason,
          Is_Pending: this.consideringRequest.Is_Pending
        },
        {
          headers: {
            Authorization: 'Bearer ' + this.user.token
          }
        }).then(() => {
        this.$store.dispatch('setSuccess', { successMsg: 'Request was ' + (approved ? 'approved' : this.consideringRequest.Is_Pending ? 'moved to pending' : 'rejected') })
        this.showAcceptDialog = this.showRejectDialog = this.showPendingDialog = false
        this.$emit('actionOnRequest', {
          approved,
          requestOwner: this.consideringRequest.Creator_ID
        })
        this.sendEmailAboutLAndDRequest(this.consideringRequest.Notification_ID)
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      })
    },
    sendEmailAboutLAndDRequest (notificationID) {
      this.axios.post('/api/emails/sendemailforlanddevrequest', {
        Notification_ID: notificationID
      }, {
        headers: {
          Authorization: 'Bearer ' + this.user.token
        }
      }).then(() => {
        this.$store.dispatch('setSuccess', { successMsg: 'Email sent' })
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      })
    },
    updatePayoutMonth (item) {
      this.axios.put(`/api/requests/l_and_d_payout_month/${item.Request_ID}`,
        {
          Payout_Month: item.Payout_Month
        },
        {
          headers: {
            Authorization: 'Bearer ' + this.user.token
          }
        }).then(() => {
        this.$store.dispatch('setSuccess', { successMsg: 'Payout month updated' })
      }).catch(error => {
        this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
      })
    }
  },
  watch: {
    groupBy: {
      handler (val, oldVal) {
        this.groupByValue = val.map(el => el.value)
        this.groupByText = val.map(el => el.text)
      },
      deep: true
    },
    showRejectDialog (val) {
      if (!val) {
        this.rejectionReason = null
      }
    },
    showPendingDialog (val) {
      if (!val) {
        this.pendingReason = null
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.margin-top--10 {
  margin-top: -10px;
}
</style>
